module.exports = __webpack_public_path__ + "img/n11.6962591d.jpg";